import React, { useState, useCallback, useEffect } from 'react';

import styles from './CustomLabel.module.css';

const CustomLabel = ({ label, tooltip }) => {
	const [mobileTooltipActive, setMobileTooltipActive] = useState(false);

	const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

	const handleTooltipClick = useCallback(
		(e) => {
			if (isMobile) {
				e.preventDefault();
				e.stopPropagation();
				setMobileTooltipActive((prev) => !prev);
			}
		},
		[isMobile]
	);

	useEffect(() => {
		if (!mobileTooltipActive) return;
		const handleClose = () => setMobileTooltipActive(false);
		document.addEventListener('click', handleClose);
		return () => document.removeEventListener('click', handleClose);
	}, [mobileTooltipActive]);

	return (
		<div className="flex items-start">
			<span className="text-base md:text-2xl text-sfi-blue whitespace-nowrap">{label}</span>
			{tooltip && (
				<div
					className={`${styles.info_icon} ${mobileTooltipActive ? styles.mobile_tooltip_active : ''}`}
					data-tooltip={tooltip}
					onClick={handleTooltipClick}
				></div>
			)}
		</div>
	);
};

export default CustomLabel;
